import React from "react";
import "./MfaModal.css";

interface Props {
  show: boolean;
  onSave: () => void;
  btnName: string;
  children: React.ReactNode;
}

const MfaModal: React.FC<Props> = ({ show, onSave, btnName, children }) => {
  if (!show) return null;

  return (
    <div className="mfa_modal_overlay">
      <div className="mfa_modal_content">
        {children}
        <button onClick={onSave} className="close_btn">
          {btnName}
        </button>
      </div>
    </div>
  );
};

export default MfaModal;
